<template>
  <section v-on:click="sectionClicked" class="features">
    <div class="leftImg" v-on:mouseover="sliderMouseEnter"
      v-on:mouseleave="sliderMouseLeave" v-on:mouseup="sliderMouseLeave"
      :class="{fs: section.config && section.config.fullScreen,
      rightImg: section.type === 'Right Image'}">
      <div class="cnt leftImgIn">
        <div class="theImg" v-if="section.items && section.items.length > 0
          && section.type === 'Left Image'">
          <img :src="section.items[0].imageMd">
        </div>
        <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
          <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
          <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
        </div>
        <div class="theImg" v-if="section.items && section.items.length > 0
          && section.type === 'Right Image'">
          <img :src="section.items[0].imageMd">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      maru1Offset: 40,
      scrolled: false,
      newsIdx: 0,
      ch: null,
      loading: true,

      /**
       * Slider
       *
       */
      sliders: [],
      slideActive: 0,
      sliderpuase: false,
      sliderpuaseForced: false,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sliderMouseEnter() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = true;
    },
    sliderMouseLeave() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = false;
    },
    forceSliderPause() {
      setTimeout(() => {
        this.sliderpuase = !this.sliderpuase;
        this.sliderpuaseForced = this.sliderpuase;
      });
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    prevNews() {
      if (this.newsIdx < 1) return;
      this.newsIdx -= 1;
    },
    nextNews() {
      if (this.newsIdx > 2) return;
      this.newsIdx += 1;
    },
    nextNews2() {
      if (this.newsIdx > 3) return;
      this.newsIdx += 1;
    },
    openVideo(item) {
      this.$refs.videoDialog.open(item.media);
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.leftImg{
  .leftImgIn{
    display: flex;
    align-items: center;
    @media (max-width: 840px) {
      display: block;
    }
    .sectionHeader{
      text-align: left;
      padding-left: 60px;
      width: 40%;
      box-sizing: border-box;
      @media (max-width: 1260px) {
        width: 46%;
      }
      @media (max-width: 840px) {
        width: auto;
        text-align: center;
        padding: 30px 0 0;
      }
      @media (max-width: 640px) {
        padding: 16px 0 0;
      }
      .sectionTitle{
        font-size: 46px;
        line-height: 1.2;
        margin: 0 0 16px;
        @media (max-width: 1260px) {
          font-size: 38px;
        }
        @media (max-width: 840px) {
          font-size: 26px;
          margin: 0 0 10px;
        }
      }
      .sectionDesc{
        margin: 0;
        font-size: 18px;
        line-height: 1.3;
        max-width: none;
      }
    }
    .theImg{
      width: 60%;
      text-align: center;
      @media (max-width: 1260px) {
        width: 54%;
      }
      @media (max-width: 840px) {
        width: auto;
      }
      img{
        width: 100%;
        height: auto;
        border-radius: 10px;
        @media (max-width: 840px) {
          max-width: 480px;
        }
      }
    }
  }
  &.rightImg{
    .leftImgIn{
      .sectionHeader{
        text-align: right;
        padding-left: 0;
        padding-right: 60px;
        @media (max-width: 840px) {
          padding: 0 0 30px;
          text-align: center;
        }
        @media (max-width: 640px) {
          padding: 0 0 16px;
        }
      }
    }
  }
}
</style>
